module.exports = __webpack_public_path__ + "static/img/news.08f6aec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news/news.png
// module id = k82R
// module chunks = 0